// filepath: d:\projects\giveinkind\inkind-monorepo\packages\@gik\core\pages\ProductsSitemap.tsx
import { useSiteMap } from '@gik/api/legal';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { PageSection } from '@gik/ui-legacy/gik/PageSection';
import React from 'react';
import { useEnvStore } from '../store/EnvStore';
import bemBlock from '../utils/bemBlock';
import { ErrorPageSection } from './Error/ErrorPageSection';
import { SitemapSectionView } from './SitemapSectionView';

function ProductsSitemapComp() {
  const bem = bemBlock('sitemap');
  const { data } = useSiteMap();
  const rawBaseUrl = useEnvStore.getState().FRONTEND_BASE_URL || '/';
  const frontendBaseUrl = rawBaseUrl.endsWith('/') ? rawBaseUrl : rawBaseUrl + '/';

  const prefixes = {
    products: 'products',
  };

  const products = React.useMemo(() => {
    return data
      ?.filter(item => item.url.startsWith(prefixes.products + '/'))
      .map(page => {
        return {
          url: page.url.replace(prefixes.products + '/', ''),
          title: page.title,
        };
      });
  }, [data, prefixes.products]);

  return (
    <PageSection className={bem()}>
      <div className="tw-flex tw-flex-wrap">
        <SitemapSectionView baseUrl={frontendBaseUrl} title="Products" items={products} prefix={prefixes.products} />
      </div>
    </PageSection>
  );
}

export const ProductsSitemapPage = withComponentErrorBoundary(ProductsSitemapComp, { ErrorFallback: ErrorPageSection });
